module.exports = __webpack_public_path__ + "images/kihnu/routes/pointers/SOR-TRI-SOR.png";